export default "__VITE_ASSET__5gfUmUja__"